<template>
    <div>
        <div v-for="btn in templateArgs.btns" @click="btn.clickHandler(templateArgs)" v-show="btn.show" class="pointer">
            <i v-if="btn.icon" :class="btn.icon"></i>
            {{ btn.text ? btn.text : (btn.tooltip ? btn.tooltip : '') }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BtnsTemplate',

        data() {
            return {
                templateArgs: {}
            };
        },
        mounted() {
            const container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({container});
        },
        methods: {}
    };
</script>

<style>
</style>
